import {DetailActions} from './DetailActions'
import {DetailLabel} from './DetailLabel'

import {StaticPartComponentDto, StaticPartDTO} from '@refra/modules/refra-static-parts/types'

export interface DetailHeaderProps {
  staticPart: StaticPartDTO
  selectedComponent: StaticPartComponentDto
  interventionDate: string
}
export const DetailHeader = ({
  staticPart,
  selectedComponent,
  interventionDate
}: DetailHeaderProps) => {
  return (
    <div className={'flex flex-row justify-between'}>
      <DetailLabel
        staticPartName={staticPart.name}
        componentType={selectedComponent.type}
        interventionDate={interventionDate}
      />
      <DetailActions />
    </div>
  )
}
